import React from "react";
import { FiCalendar, FiRepeat } from "react-icons/fi";

/**
 * Component cho phép user chọn giữa weekly và fixed-dates schedule mode
 * @param {Object} props
 * @param {'weekly' | 'fixed-dates'} props.value - Giá trị hiện tại
 * @param {Function} props.onChange - Callback khi mode thay đổi
 * @param {Boolean} props.disabled - Disable selector
 */
const ScheduleModeSelector = ({ value, onChange, disabled = false }) => {
  const modes = [
    {
      value: "weekly",
      label: "Lặp lại theo tuần",
      icon: FiRepeat,
      description: "Đăng bài lặp lại theo các ngày trong tuần",
    },
    {
      value: "fixed-dates",
      label: "Ngày cố định",
      icon: FiCalendar,
      description: "Đăng bài vào các ngày cụ thể",
    },
  ];

  return (
    <div className="mb-6">
      <label className="block text-gray-700 font-medium mb-3">
        Chế độ lịch đăng bài
      </label>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {modes.map((mode) => {
          const Icon = mode.icon;
          const isSelected = value === mode.value;

          return (
            <button
              key={mode.value}
              type="button"
              onClick={() => !disabled && onChange(mode.value)}
              disabled={disabled}
              className={`
                relative p-4 rounded-lg border-2 transition-all duration-200
                ${
                  isSelected
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-300 bg-white hover:border-blue-300 hover:bg-blue-50/30"
                }
                ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
              `}
            >
              <div className="flex items-start gap-3">
                <div
                  className={`
                  flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center
                  ${
                    isSelected
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-gray-600"
                  }
                `}
                >
                  <Icon size={20} />
                </div>

                <div className="flex-1 text-left">
                  <div
                    className={`font-medium mb-1 ${
                      isSelected ? "text-blue-700" : "text-gray-800"
                    }`}
                  >
                    {mode.label}
                  </div>
                  <div className="text-sm text-gray-600">
                    {mode.description}
                  </div>
                </div>

                {isSelected && (
                  <div className="absolute top-3 right-3">
                    <svg
                      className="w-5 h-5 text-blue-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>

      {/* Tooltip/Help text */}
      <div className="mt-3 text-sm text-gray-500 bg-gray-50 p-3 rounded-md">
        <span className="font-medium">💡 Mẹo:</span>{" "}
        {value === "weekly"
          ? "Chế độ lặp lại theo tuần phù hợp cho lịch đăng bài thường xuyên và đều đặn."
          : "Chế độ ngày cố định phù hợp cho các chiến dịch đặc biệt, sự kiện hoặc ngày lễ."}
      </div>
    </div>
  );
};

export default ScheduleModeSelector;
